import { Header } from '@/features/header';
import { Navigation } from '@/features/navigation';
import { Outlet } from 'react-router';

export default function MainLayout() {
  return (
    <div className="flex h-screen flex-col overflow-hidden bg-gray-100">
      <Header />
      <div className="flex flex-1 overflow-hidden">
        <Navigation />
        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
